<template>
  <el-dialog
    v-drag
    :custom-class="'le-dialog ' + customClass"
    :title="title"
    :visible.sync="dialogShowStatus"
    :width="width"
    :modal="modal"
    :top="top"
    :close-on-click-modal="closeOnClickModal"
    :close-on-press-escape="true"
    :modal-append-to-body="modalAppendToBody"
    :append-to-body="appendToBody"
    @close="handleClose">

    <template slot="title">
      <slot name="title" />
    </template>

    <slot />

    <template slot="footer">
      <slot name="footer" />
    </template>

  </el-dialog>
</template>

<script>
export default {
  name: 'LeDialog',
  props: {
    width: {
      type: String,
      default: '60%'
    },
    modal: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    customClass: {
      type: String,
      default: 'le-form-dialog'
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    modalAppendToBody: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    top: {
      type: String,
      default: '15vh'
    }
  },
  computed: {
    dialogShowStatus: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  created() {
  },
  methods: {
    handleClose() {
      this.$emit('changeShow', false);
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../static/styles/dialog";
</style>
